import { k as jsxRuntimeExports, n as DynamicMath } from "./doenetml-a_KitGQm.js";
function renderLabelWithLatex({
  label,
  labelHasLatex
}) {
  if (labelHasLatex) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicMath, { latex: label });
  }
  return label;
}
function accessibleLabelText({
  label,
  labelHasLatex,
  fallback
}) {
  const trimmed = label.trim();
  if (!trimmed) {
    return fallback;
  }
  return labelHasLatex ? fallback : trimmed;
}
export {
  accessibleLabelText as a,
  renderLabelWithLatex as r
};
